import script from "./AssetOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetOverview.vue?vue&type=script&setup=true&lang=ts"

import "./AssetOverview.vue?vue&type=style&index=0&id=227a183c&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227a183c"]])

export default __exports__